import SumsubWebSdk from '@sumsub/websdk-react';

const completionMessages = new Set([
  'idCheck.onApplicantStatusChanged',
  'idCheck.applicantReviewComplete',
]);

const sdkLanguage = (lang) => String(lang || 'en').toLowerCase().startsWith('zh') ? 'zh' : 'en';

const SumsubVerification = ({ accessToken, refreshAccessToken, onComplete, onError, lang }) => (
  <div className="min-h-[560px] w-full" data-testid="sumsub-sdk">
    <SumsubWebSdk
      accessToken={accessToken}
      expirationHandler={refreshAccessToken}
      config={{ lang: sdkLanguage(lang) }}
      options={{ addViewportTag: false, adaptIframeHeight: true }}
      onMessage={(type, payload) => {
        if (completionMessages.has(type)) onComplete?.(payload);
      }}
      onError={onError}
    />
  </div>
);

export default SumsubVerification;
